import React from "react";

const VolumeOnIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 1.99C11 1.61 10.77 1.26 10.43 1.09C10.08 0.93 9.67 0.97 9.37 1.21L4.64 4.99H1C0.44 4.99 0 5.44 0 5.99V11.99C0 12.55 0.44 12.99 1 12.99H4.64L9.37 16.78C9.67 17.02 10.08 17.06 10.43 16.90C10.77 16.73 11 16.38 11 15.99V1.99ZM5.62 6.78L9 4.08V13.91L5.62 11.21C5.44 11.07 5.22 10.99 5 10.99H2V6.99H5C5.22 6.99 5.44 6.92 5.62 6.78ZM18.77 1.22C18.38 0.83 17.75 0.83 17.36 1.22C16.97 1.61 16.97 2.24 17.36 2.63C19.05 4.32 19.99 6.61 19.99 8.99C19.99 11.38 19.05 13.67 17.36 15.36C16.97 15.75 16.97 16.38 17.36 16.77C17.75 17.16 18.38 17.16 18.77 16.77C20.83 14.71 21.99 11.91 21.99 8.99C21.99 6.08 20.83 3.28 18.77 1.22ZM15.24 4.75C14.85 4.36 14.22 4.36 13.83 4.75C13.44 5.14 13.44 5.77 13.83 6.16C14.58 6.91 15.00 7.93 15.00 8.99C15.00 10.05 14.58 11.07 13.83 11.82C13.44 12.21 13.44 12.84 13.83 13.23C14.22 13.62 14.85 13.62 15.24 13.23C16.37 12.11 17.00 10.58 17.00 8.99C17.00 7.40 16.37 5.87 15.24 4.75Z"
      fill={fillColor}
    />
  </svg>
);

export default VolumeOnIcon;
